import React from 'react';
import { Link } from 'react-router-dom';

const PublicFooter: React.FC = () => {
  return (
    <footer className="bg-slate-800 text-slate-200 py-8">
      <div className="container mx-auto px-4">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8">
          <div>
            <h4 className="text-white font-bold mb-4">آزمایشگاه رازی</h4>
            <img src="/assets/img/logoRazi.png" alt="آزمایشگاه رازی" className="h-12 mb-4" />
            <p className="text-sm">آزمایشگاه تشخیص طبی، آسیب شناسی و ژنتیک رازی رشت</p>
          </div>
          
          <div>
            <h4 className="text-white font-bold mb-4">دسترسی سریع</h4>
            <ul className="space-y-2">
              <li><Link to="/" className="hover:text-white">صفحه اصلی</Link></li>
              <li><Link to="/about" className="hover:text-white">درباره ما</Link></li>
              <li><Link to="/contact" className="hover:text-white">تماس با ما</Link></li>
              <li><Link to="/guide" className="hover:text-white">راهنما..</Link></li>
            </ul>
          </div>
          
          <div>
            <h4 className="text-white font-bold mb-4">خدمات</h4>
            <ul className="space-y-2">
              <li><Link to="/home" className="hover:text-white">ثبت درخواست آزمایش</Link></li>
              <li><Link to="/home" className="hover:text-white">مشاهده نتایج</Link></li>
              <li><Link to="/home" className="hover:text-white">پیگیری درخواست</Link></li>
            </ul>
          </div>
          
          <div>
            <h4 className="text-white font-bold mb-4">اطلاعات تماس</h4>
            <ul className="space-y-2">
              <li className="flex items-center gap-2">
                <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3 5a2 2 0 012-2h3.28a1 1 0 01.948.684l1.498 4.493a1 1 0 01-.502 1.21l-2.257 1.13a11.042 11.042 0 005.516 5.516l1.13-2.257a1 1 0 011.21-.502l4.493 1.498a1 1 0 01.684.949V19a2 2 0 01-2 2h-1C9.716 21 3 14.284 3 6V5z" />
                </svg>
                <span>3401-013</span>
              </li>
              <li className="flex items-center gap-2">
                <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3 8l7.89 5.26a2 2 0 002.22 0L21 8M5 19h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z" />
                </svg>
                <span>info@razipath.net</span>
              </li>
              <li>
  <a
    referrerPolicy="origin"
    target="_blank"
   
    href="https://trustseal.enamad.ir/?id=626413&Code=joUGvN46zQH3axIkEeP6ajWp9YYw0VuU"
    data-code="joUGvN46zQH3axIkEeP6ajWp9YYw0VuU"
  >
    <img
      referrerPolicy="origin"
      src="https://trustseal.enamad.ir/logo.aspx?id=626413&Code=joUGvN46zQH3axIkEeP6ajWp9YYw0VuU"
      alt="Enamad Trust Seal"
      style={{ cursor: 'pointer' }}
    />
  </a>
</li>
            </ul>
          </div>
        </div>
        
        <div className="border-t border-slate-700 mt-8 pt-8 text-sm text-center">
          <p>© {new Date().getFullYear()} آزمایشگاه رازی. تمامی حقوق محفوظ است.</p>
        </div>
      </div>
    </footer>
  );
};

export default PublicFooter; 